import { Fragment } from 'react';
import { H7 } from 'UIComponents/elements/headings';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getFileFromPath = path => path.split('/').pop();
export const ImageList = ({
  images,
  subHeader,
  action,
  onTrackAction,
  fixButton: FixButton
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H7, {
      className: "m-left-6 m-bottom-2",
      children: subHeader
    }), /*#__PURE__*/_jsx(UIExpandableText, {
      maxHeight: 128,
      children: /*#__PURE__*/_jsx(UIList, {
        className: "m-bottom-0",
        styled: true,
        children: images.map((img, key) => {
          const {
            src,
            moduleId,
            globalResourcePath
          } = img;
          if (!src) {
            return null;
          }
          const filePath = getFileFromPath(src);
          if (moduleId) {
            return /*#__PURE__*/_jsxs(Fragment, {
              children: [/*#__PURE__*/_jsx(UILink, {
                onClick: () => {
                  if (onTrackAction) {
                    onTrackAction();
                  }
                  action({
                    moduleId,
                    globalResourcePath
                  });
                },
                children: /*#__PURE__*/_jsx("span", {
                  children: filePath
                })
              }), FixButton && /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(FixButton, {
                  moduleId: moduleId,
                  img: img
                })
              })]
            }, key);
          } else {
            return /*#__PURE__*/_jsx("span", {
              children: filePath
            }, key);
          }
        })
      })
    })]
  });
};